<template>
    <div>
      <div class="popup-info popup-icon-info">
          <svg class="big-icon" style="width: 48px; height: 42px;">
            <use xlink:href="@/assets/img/big-icons-sprite.svg#quest"></use>
          </svg>

          <div class="text mt24">
			  <div class="text-size-l text-color-yellow text-bold info-title">Создать пользователя?</div>

              <p class="info-text">
				  Пользователю будет отправлено СМС,<br>
				  а также E-mail со ссылкой на договор
              </p>
          </div>
          <div class="mt24">
              <submit-btn @click.native="send" :type="CreateUserBtnType">
                  <span class="i i-ok7 mr4" style="margin-top: -2px;" v-if="CreateUserBtnType != 'load'"></span>Подтвердить
              </submit-btn>
          </div>
      </div>
    </div>
</template>

<script>
    import {mapState} from 'vuex';
    import SubmitBtn from '@/components/forms/SubmitBtn.vue';

    export default {
        name: "CreateUser",
        components: {
            SubmitBtn,
        },
        data: function(){
            return {
                CreateUserBtnType: 'normal',
            }
        },
        methods: {
            close: function () {
                this.$store.commit('popups/close', {name: this.popups.createUser.name});
            },
            send(){
                this.$store.dispatch('rulesStaff/addUser', {form:this.form}).then((result)=>{
                    this.form.btnType = 'normal';
                    this.$emit('change', this.form.department);
                    if(result.status == 'error'){
                        for(let e in result.statusErrors) {
                            if(result.statusErrors[e] == 'phoneIsUsed'){
                                this.repeatFieldError('phone');
                                this.form.worker.phone.errorType = 'use';
                            }
                            if(result.statusErrors[e] == 'emailIsUsed'){
                                this.repeatFieldError('email');
                                this.form.worker.email.errorType = 'use';
                            }
                        }
                    } else {
                        this.close();
                    }
                    this.$store.commit('rulesStaff/setUserForm', {})
                });
            }
        },
        computed: {
            ...mapState({
                popups: state => state.popups.items,
                form: state => state.rulesStaff.form,
            }),

        }
    }
</script>

<style scoped>

</style>
